import api from '@/api_alv'
import Vue from 'vue'
import i18n from '@/assets/i18n/i18n'
import { router } from '@/router.js'

const DIR = 'contracts/label'
const DEFAULT_CONTRACT = {
    "id": 0,
    "alvId": "ALV000000000CL",
    "contractName"              : null,
    "contractType"              : null,
    "connectedTo"               : null,
    "contractDate"              : null,
    "alertOn"                   : null,
    "notes"                     : null,
    "initialBalance"            : null,
    "initialBalancePeriod"      : { "num": null, "period": null, "year": null},
    "tags"                      : null,
    "contractDate"              : null,
    "validFrom"                 : null,
    "validUntil"                : null,
    "reminderDate"              : null,
    "reserve"                   : null,
    "resolutionPeriod"          : null,
    "billingCycle"              : null,
    "licensor"                  : null,
    "splits"                    : [],
    "tracks"                    : [],
    "assignToReleaseOptions"    : []
}

const DEFAULT_SPLITS = {
    "id": 0,
    "base": null,
    "category": 'all',
    "license": null,
    "salesType": null,
    "salesUnit": null,
    "share": null,
    "region": {
        "exclude": [],
        "include": []
    },
    "licensor": null
}

const DEFAULT_TRACK = {
    "id": 0,
    "title": null,
    "selectedReleases": [],
    "performer": null,
    "isrc": null,
    "releases": []
}

const DEFAULT_ADVANCE = {
    "id": 0,
    "clearanceOfAdvances": null,
    "enteredBy": null,
    "enteredOn": null,
    "entered": "manual",
    "credit": null,
    "balance": null,
}

const DEFAULT_RESERVES = {
    "amount": null,
    "entered": "manual",
    "enteredOn": null,
    "id": 0,
    "reserve": null,
    "reverseAccrualsIn": {
        "num": null, 
        "period": "notDefined", 
        "year": null
    },
    "setUpAccrualsIn": {
        "num": null, 
        "period": "notDefined", 
        "year": null
    },
    "sourceOfReserve": null
}

const DEFAULT_COSTS = {
    "id"                : 0,
    "amount"            : null,
    "assignToRelease"   : null,
    "costGroup"         : null,
    "country"           : null,
    "date"              : null,
    "description"       : null,
    "documentNumber"    : null,
    "paidOn"            : null,
    "recipient"         : null,
    "split"             : 100,
    "accountingPeriod"  : {
        "num": null, 
        "period": "notDefined", 
        "year": null
    }
}

const state = {
        dialogSvgLink: '',
    // List
        labelContracts: [],
        labelReminders: {},
        selectedLabelContracts: [],
        labelContractsSearch: "" ,
        selectedLabelContractsQualityFilter: [],
        isAllSelectedLabelContracts: false,
        selectedLabelContractsAction: [],
        expandedLabelContracts:[],
        labelContractsServerSideSortingOptions: {
            sortBy: ['contractName'],
            sortDesc: [false],
            mustSort: true
        },

    //Actions
        labelContractsDetailsSelectedCompany:[],
    // Actions:export
        showContractsLabelExportDialog: false,
        contractsLabelExportAll: false,
        contractsLabelExportType: "mappings",
        contractsLabelExportMappingId: null,
        contractsLabelExportIncludeTracksReleases: false,
    // Details
        defaultNewLabelContracts: DEFAULT_CONTRACT,
        labelContractsDetails: DEFAULT_CONTRACT,
        labelContractsUniqueId: '',
        labelContractsLicensorOptions: [],
        // SPLITS Panel
        labelContractsSplits: [],
        selectedLabelContractsSplits: [],
        selectedLabelContractsMediaFiles:[],
        defaultLabelContractsSplits: DEFAULT_SPLITS,
        labelContractsSplitsEditingDialogDetails: DEFAULT_SPLITS,
        // Regions
        labelContractsSplitsEditingDialogIncludeOptions: [],
        labelContractsSplitsEditingDialogExcludeOptions: [],
        labelContractsSplitsEditingDialogDetailsInclude: [],
        labelContractsSplitsEditingDialogDetailsExclude: [],

        //GROUPED CONTRACTS Panel
        labelContractsGroupedContracts: [],
        showLabelContractsGroupDialog: false,
        labelContractsGroupDialogName: '',

        // TRACKS/RELEASES Panel
        labelContractsTracksReleases: [],
        selectedLabelContractsTracksReleases: [],
        trackReleasesForSubCataloguesSearch: "",
        selectedTracksReleasesForSubCatalogues: [],
        showTracksReleasesDeleteResultListButton: false,
        tracksReleasesSearchId: "",
        labelContractsTracksReleasesSearch: "",
        showSetTracksReleasesTypeDialog: false,
        // Paging
        labelContractsTracksReleasesTotalRecords: 0,
        labelContractsTracksReleasesTotalListed: 0,
        labelContractsTracksReleasesCurrentPage: 1,
        labelContractsTracksReleasesNumberOfPages: 0,
        // Editing
        defaultLabelContractsTracksReleases: DEFAULT_TRACK,
        labelContractsTracksReleasesEditingDialogDetails: DEFAULT_TRACK,
        showLabelContractsTracksReleasesEditingDialog: false,
        // showLabelContractsMoveContractsDialog:false,
        // Autocomplete track title
        labelContractsTracksReleasesTrackTitleOptions: [],
        labelContractsIsTrackTitelReadOnly: false,
        // Add Release
        selectedReleasesForContract: [],
        releasesForContractSearch: "",
        totalReleasesForContractListed: "",
        totalReleasesForContractRecords: "",
        labelContractsSortingPagingOptions: {
            sortBy: ['trackTitle'],
            sortDesc: [false],
            mustSort: true
        },

        // ADVANCE Panel
        labelContractsAdvance: [],
        selectedLabelContractsAdvance: [],
        defaultLabelContractsAdvance: DEFAULT_ADVANCE,
        showLabelContractsAdvanceEditingDialog: false,
        labelContractsAdvanceEditingDialogDetails: DEFAULT_ADVANCE,

        // RESERVES Panel
        labelContractsReserves: [],
        selectedLabelContractsReserves: [],
        defaultLabelContractsReserves: DEFAULT_RESERVES,
        showLabelContractsReservesEditingDialog: false,
        labelContractsReservesEditingDialogDetails: DEFAULT_RESERVES,

        // COSTS Panel
        labelContractsCosts: [],
        selectedLabelContractsCosts: [],
        defaultLabelContractsCosts: DEFAULT_COSTS,
        showLabelContractsCostsEditingDialog: false,
        labelContractsCostsEditingDialogDetails: DEFAULT_COSTS,
        labelContractsCostsRecipientOptions: [],
        labelContractsCostsAssignToReleaseOptions: [],
        // Paging
        labelContractsCostsTotalRecords: 0,
        labelContractsCostsTotalListed: 0,
        labelContractsCostsCurrentPage: 1,
        labelContractsCostsNumberOfPages: 0,

            //MEDIA Panel
        labelContractsMedia: [],
        labelContractsMediaCheckbox:[],
    }

const getters = {
        getDialogSvgLink(state) { return state.dialogSvgLink },
    // List
        getLabelContracts(state) { return state.labelContracts },
        getLabelReminders(state) { return state.labelReminders },
        getSelectedLabelContracts(state) { return state.selectedLabelContracts },
        getLabelContractsSearch(state) { return state.labelContractsSearch },
        getSelectedLabelContractsQualityFilter(state) { return state.selectedLabelContractsQualityFilter },
        getIsAllSelectedLabelContracts(state) { return state.isAllSelectedLabelContracts },
        getSelectedLabelContractsAction(state) { return state.selectedLabelContractsAction },
        getExpandedLabelContracts(state) { return state.expandedLabelContracts },
        getLabelContractsServerSideSortingOptions(state) { return state.labelContractsServerSideSortingOptions },
    //Actions
        getLabelContractsDetailsSelectedCompany(state) { return state.labelContractsDetailsSelectedCompany },
    // Actions:export
        getShowContractsLabelExportDialog                   (state) { return state.showContractsLabelExportDialog },
        getContractsLabelExportDetailsType                  (state) { return state.contractsLabelExportType },
        getContractsLabelExportAll                          (state) { return state.contractsLabelExportAll },
        getContractsLabelExportDetailsMappingId             (state) { return state.contractsLabelExportMappingId },
        getContractsLabelExportTracksReleasesCheckbox       (state) { return state.contractsLabelExportIncludeTracksReleases },
        // Details
        getDefaultNewLabelContracts                         (state) { return state.defaultNewLabelContracts },
        getLabelContractsDetails                            (state) { return state.labelContractsDetails },
        getLabelContractsUniqueId                           (state) { return state.labelContractsUniqueId },
        getLabelContractsLicensorOptions                    (state) { return state.labelContractsLicensorOptions },

        // Edit Form FIELDS
        getLabelContractsDetailsContractName                (state) { return state.labelContractsDetails.contractName },
        getLabelContractsDetailsAlvId                       (state) { return state.labelContractsDetails.alvId },
        getLabelContractsDetailsNotes                       (state) { return state.labelContractsDetails.notes },
        getLabelContractsDetailsType                        (state) { return state.labelContractsDetails.contractType },
        getLabelContractsDetailsInitialBalance              (state) { return state.labelContractsDetails.initialBalance },
        getLabelContractsDetailsInitialBalancePeriod        (state) { return state.labelContractsDetails.initialBalancePeriod },
        getLabelContractsDetailsTags                        (state) { return state.labelContractsDetails.tags },
        getLabelContractsDetailsContractDate                (state) { return state.labelContractsDetails.contractDate },
        getLabelContractsDetailsValidFrom                   (state) { return state.labelContractsDetails.validFrom },
        getLabelContractsDetailsValidUntil                  (state) { return state.labelContractsDetails.validUntil },
        getLabelContractsDetailsReminderDate                (state) { return state.labelContractsDetails.reminderDate },
        getLabelContractsDetailsReserve                     (state) { return state.labelContractsDetails.reserve },
        getLabelContractsDetailsResolutionPeriod            (state) { return state.labelContractsDetails.resolutionPeriod },
        getLabelContractsDetailsBillingCycle                (state) { return state.labelContractsDetails.billingCycle },
        getLabelContractsDetailsLicensor                    (state) { return state.labelContractsDetails.licensor },
        getLabelContractsDetailsConnectedTo                 (state) { return state.labelContractsDetails.connectedTo },
        getLabelContractsDetailsContractDate                (state) { return state.labelContractsDetails.contractDate },
        
        // Period
        getSelectedPeriodNumberLabelContracts (state) { 
            if (state.labelContractsDetails.initialBalancePeriod !== undefined){
                return state.labelContractsDetails.initialBalancePeriod.num 
            } else {
                return null
            }
        },
        getSelectedPeriodTimeUnitLabelContracts (state) { 
            if (state.labelContractsDetails.initialBalancePeriod !== undefined){
                return state.labelContractsDetails.initialBalancePeriod.period 
            } else {
                return null
            }
        },
        getSelectedPeriodYearLabelContracts (state) { 
            if (state.labelContractsDetails.initialBalancePeriod !== undefined){
                return state.labelContractsDetails.initialBalancePeriod.year 
            } else {
                return null
            }
        },
        //MEDIA Panel
        getSelectedLabelContractsMediaFiles(state) { return state.selectedLabelContractsMediaFiles },

        // SPLITS Panel
        getLabelContractsSplits(state) { return state.labelContractsSplits },
        getSelectedLabelContractsSplits(state) { return state.selectedLabelContractsSplits },
        // Editing Dialog
        getDefaultLabelContractsSplits(state) { return state.defaultLabelContractsSplits },
        getLabelContractsSplitsEditingDialogDetails(state) { return state.labelContractsSplitsEditingDialogDetails },
        getLabelContractsSplitsDetailsSalesType(state) { return state.labelContractsSplitsEditingDialogDetails.salesType },
        getLabelContractsSplitsDetailsLicense (state) { return state.labelContractsSplitsEditingDialogDetails.license },
        getLabelContractsSplitsDetailsSalesUnit(state) { return state.labelContractsSplitsEditingDialogDetails.salesUnit },
        getLabelContractsSplitsDetailsBase (state) { return state.labelContractsSplitsEditingDialogDetails.base },
        getLabelContractsSplitsDetailsShares (state) { return state.labelContractsSplitsEditingDialogDetails.share },
        getLabelContractsSplitsDetailsCategory (state) { return state.labelContractsSplitsEditingDialogDetails.category },
        // Regions
        getLabelContractsSplitsEditingDialogIncludeOptions(state) { return state.labelContractsSplitsEditingDialogIncludeOptions },
        getLabelContractsSplitsEditingDialogExcludeOptions(state) { return state.labelContractsSplitsEditingDialogExcludeOptions },
        getLabelContractsSplitsEditingDialogDetailsInclude(state) { 
            if(state.labelContractsSplitsEditingDialogDetails.region === undefined) return []
            else return state.labelContractsSplitsEditingDialogDetails.region.include 
        },
        getLabelContractsSplitsEditingDialogDetailsExclude(state) { 
            if(state.labelContractsSplitsEditingDialogDetails.region === undefined) return []
            else return state.labelContractsSplitsEditingDialogDetails.region.exclude 
        },

        //GROUPED CONTRACTS Panel

        getLabelContractsGroupedContracts(state) { return state.labelContractsGroupedContracts },
        getShowLabelContractsGroupDialog(state) { return state.showLabelContractsGroupDialog },
        getLabelContractsGroupDialogName(state) { return state.labelContractsGroupDialogName },
        getLabelContractsDetailGroupName(state) {
            let details = state.labelContractsDetails
            if(details && details.groupName) return details.groupName
            return ''
        },

        // TRACKS/RELEASES Panel
        getLabelContractsTracksReleases(state) { return state.labelContractsTracksReleases },
        getSelectedLabelContractsTracksReleases(state) { return state.selectedLabelContractsTracksReleases },
        getDefaultLabelContractsTracksReleases(state) { return state.defaultLabelContractsTracksReleases },
        getShowTracksReleasesDeleteResultListButton(state) { return state.showTracksReleasesDeleteResultListButton },
        getTracksReleasesSearchId(state) { return state.tracksReleasesSearchId },
        getLabelContractsTracksReleasesSearch(state) { return state.labelContractsTracksReleasesSearch },
        getShowSetTracksReleasesTypeDialog(state) { return state.showSetTracksReleasesTypeDialog },


        // Paging
        getLabelContractsTracksReleasesTotalRecords(state) { return state.labelContractsTracksReleasesTotalRecords },
        getLabelContractsTracksReleasesTotalListed(state) { return state.labelContractsTracksReleasesTotalListed },
        getLabelContractsTracksReleasesCurrentPage(state) { return state.labelContractsTracksReleasesCurrentPage },
        getLabelContractsTracksReleasesNumberOfPages(state) { return state.labelContractsTracksReleasesNumberOfPages },
        // Editing Dialog
        getShowLabelContractsTracksReleasesEditingDialog(state) { return state.showLabelContractsTracksReleasesEditingDialog },
        // getShowLabelContractsMoveContractsDialog(state) { return state.showLabelContractsMoveContractsDialog },
        getLabelContractsTracksReleasesEditingDialogDetails(state) { return state.labelContractsTracksReleasesEditingDialogDetails },
        getLabelContractsTracksReleasesDetailsSelectedReleases(state) { return state.labelContractsTracksReleasesEditingDialogDetails.selectedReleases },
        getLabelContractsTracksReleasesDetailsTrackTitle(state) { return state.labelContractsTracksReleasesEditingDialogDetails.title },
        getLabelContractsTracksReleasesDetailsArtist(state) { return state.labelContractsTracksReleasesEditingDialogDetails.performer },
        getLabelContractsTracksReleasesDetailsIsrc(state) { return state.labelContractsTracksReleasesEditingDialogDetails.isrc },
        // Track Title Autocomplete
        getLabelContractsTracksReleasesTrackTitleOptions(state) { return state.labelContractsTracksReleasesTrackTitleOptions },
        getLabelContractsIsTrackTitelReadOnly(state) { return state.labelContractsIsTrackTitelReadOnly },
        // Add Release
        getSelectedReleasesForContract(state) { return state.selectedReleasesForContract }, 
        getReleasesForContractSearch(state) { return state.releasesForContractSearch },
        getTotalReleasesForContractListed(state) { return state.totalReleasesForContractListed },
        getTotalReleasesForContractRecords(state) { return state.totalReleasesForContractRecords },

        getLabelContractsSortingPagingOptions(state) { return state.labelContractsSortingPagingOptions },

        // ADVANCE Panel
        getLabelContractsAdvance(state) { return state.labelContractsAdvance },
        getSelectedLabelContractsAdvance(state) { return state.selectedLabelContractsAdvance },
        getDefaultLabelContractsAdvance(state) { return state.defaultLabelContractsAdvance },
        getShowLabelContractsAdvanceEditingDialog(state) { return state.showLabelContractsAdvanceEditingDialog },
        // Editing
        getLabelContractsAdvanceEditingDialogDetails(state) { return state.labelContractsAdvanceEditingDialogDetails },
        getLabelContractsAdvanceDetailsClearanceOfAdvances(state) { return state.labelContractsAdvanceEditingDialogDetails.clearanceOfAdvances },
        getLabelContractsAdvanceDetailsCredit(state) { return state.labelContractsAdvanceEditingDialogDetails.credit },
        getLabelContractsAdvanceDetailsBalance(state) { return state.labelContractsAdvanceEditingDialogDetails.balance },

        // RESERVES Panel
        getLabelContractsReserves(state) { return state.labelContractsReserves },
        getSelectedLabelContractsReserves(state) { return state.selectedLabelContractsReserves },
        getDefaultLabelContractsReserves(state) { return state.defaultLabelContractsReserves },
        getShowLabelContractsReservesEditingDialog(state) { return state.showLabelContractsReservesEditingDialog },
        // Editing
        getLabelContractsReservesEditingDialogDetails(state) { return state.labelContractsReservesEditingDialogDetails },
        getLabelContractsReservesDetailsSourceOfReserve(state) { return state.labelContractsReservesEditingDialogDetails.sourceOfReserve },
        getLabelContractsReservesDetailsEnteredOn(state) { return state.labelContractsReservesEditingDialogDetails.enteredOn },
        getLabelContractsReservesDetailsAmount(state) { return state.labelContractsReservesEditingDialogDetails.amount },
        getLabelContractsReservesDetailsReserve(state) { return state.labelContractsReservesEditingDialogDetails.reserve },
        // Period SetUp AccrualsIn
        getLabelContractsReservesDetailsSetUpAccrualsIn(state) { return state.labelContractsReservesEditingDialogDetails.setUpAccrualsIn },
        getSelectedPeriodNumberLabelContractsReservesSetUp(state) { return state.labelContractsReservesEditingDialogDetails.setUpAccrualsIn.num },
        getSelectedPeriodTimeUnitLabelContractsReservesSetUp(state) { return state.labelContractsReservesEditingDialogDetails.setUpAccrualsIn.period },
        getSelectedPeriodYearLabelContractsReservesSetUp(state) { return state.labelContractsReservesEditingDialogDetails.setUpAccrualsIn.year },
        // Period Reverse AccrualsIn
        getLabelContractsReservesDetailsReverseAccrualsIn(state) { return state.labelContractsReservesEditingDialogDetails.reverseAccrualsIn },
        getSelectedPeriodNumberLabelContractsReserves(state) { return state.labelContractsReservesEditingDialogDetails.reverseAccrualsIn.num },
        getSelectedPeriodTimeUnitLabelContractsReserves(state) { return state.labelContractsReservesEditingDialogDetails.reverseAccrualsIn.period },
        getSelectedPeriodYearLabelContractsReserves(state) { return state.labelContractsReservesEditingDialogDetails.reverseAccrualsIn.year },

        // COSTS Panel
        getLabelContractsCosts(state) { return state.labelContractsCosts },
        getSelectedLabelContractsCosts(state) { return state.selectedLabelContractsCosts },
        getDefaultLabelContractsCosts(state) { return state.defaultLabelContractsCosts },
        getShowLabelContractsCostsEditingDialog(state) { return state.showLabelContractsCostsEditingDialog },
        getLabelContractsCostsAssignToReleaseOptions(state) { return state.labelContractsCostsAssignToReleaseOptions },

        // Editing
        getLabelContractsCostsEditingDialogDetails(state) { return state.labelContractsCostsEditingDialogDetails },
        getLabelContractsCostsDetailsCostGroup(state) { return state.labelContractsCostsEditingDialogDetails.costGroup },
        getLabelContractsCostsDetailsDate(state) { return state.labelContractsCostsEditingDialogDetails.date },
        getLabelContractsCostsDetailsPaidOn(state) { return state.labelContractsCostsEditingDialogDetails.paidOn },
        getLabelContractsCostsDetailsAmount(state) { return state.labelContractsCostsEditingDialogDetails.amount },
        getLabelContractsCostsDetailsSplit(state) { return state.labelContractsCostsEditingDialogDetails.split },
        getLabelContractsCostsDetailsCountry(state) { return state.labelContractsCostsEditingDialogDetails.country },
        getLabelContractsCostsDetailsDescription(state) { return state.labelContractsCostsEditingDialogDetails.description },
        getLabelContractsCostsDetailsDocumentNumber(state) { return state.labelContractsCostsEditingDialogDetails.documentNumber },
        getLabelContractsCostsDetailsAssignToRelease(state) { return state.labelContractsCostsEditingDialogDetails.assignToRelease },        
        getLabelContractsCostsDetailsRecipient(state) { return state.labelContractsCostsEditingDialogDetails.recipient },
        getLabelContractsCostsRecipientOptions(state) { return state.labelContractsCostsRecipientOptions },
        // Accounting Period
        getLabelContractsCostsDetailsAccountingPeriod(state) { return state.labelContractsCostsEditingDialogDetails.accountingPeriod },
        getSelectedPeriodNumberLabelContractsCostsAccountingPeriod(state) { return state.labelContractsCostsEditingDialogDetails.accountingPeriod.num },
        getSelectedPeriodTimeUnitLabelContractsCostsAccountingPeriod(state) { return state.labelContractsCostsEditingDialogDetails.accountingPeriod.period },
        getSelectedPeriodYearLabelContractsCostsAccountingPeriod(state) { return state.labelContractsCostsEditingDialogDetails.accountingPeriod.year },
        // Paging
        getLabelContractsCostsTotalRecords(state) { return state.labelContractsCostsTotalRecords },
        getLabelContractsCostsTotalListed(state) { return state.labelContractsCostsTotalListed },
        getLabelContractsCostsCurrentPage(state) { return state.labelContractsCostsCurrentPage },
        getLabelContractsCostsNumberOfPages(state)                          { return state.labelContractsCostsNumberOfPages },
        // Assign to Release
        // getAssignToReleaseOptions(state) { return state.labelContractsDetails.assignToReleaseOptions },


        getLabelContractsMedia (state) { return state.labelContractsMedia},
        getLabelContractsMediaCheckbox(state) { return state.labelContractsMediaCheckbox},
    }
    
const mutations = { 
    
    setDialogSvgLink: (state, value) => { state.dialogSvgLink = value },
    // List
        setLabelContracts: (state, labelContracts) => { state.labelContracts = labelContracts },
        setLabelReminders: (state, labelReminders) => { state.labelReminders = labelReminders },
        setSelectedLabelContracts: (state, selected) => { state.selectedLabelContracts = selected },
        setLabelContractsSearch: (state, search) => { state.labelContractsSearch = search },
        setSelectedLabelContractsQualityFilter: (state, value) => { state.selectedLabelContractsQualityFilter = value },
        setIsAllSelectedLabelContracts: (state, isSelected) => { state.isAllSelectedLabelContracts = isSelected },
        setSelectedLabelContractsAction: (state, action) => { state.selectedLabelContractsAction = action },
        setExpandedLabelContracts: (state, action) => { state.expandedLabelContracts = [action] },
        setLabelContractsServerSideSortingOptions: (state, options) => { state.labelContractsServerSideSortingOptions = options },
    //Actions
        setLabelContractsDetailsSelectedCompany: (state, action) => { state.labelContractsDetailsSelectedCompany = action },
    // Actions:export
        setShowContractsLabelExportDialog:                   (state, value) => { state.showContractsLabelExportDialog = value },
        setContractsLabelExportDetailsType:                  (state, value) => { state.contractsLabelExportType = value },
        setContractsLabelExportAll:                          (state, value) => { state.contractsLabelExportAll = value },
        setContractsLabelExportDetailsMappingId:             (state, value) => { state.contractsLabelExportMappingId = value},
        setContractsLabelExportTracksReleasesCheckbox:       (state, value) => { state.contractsLabelExportIncludeTracksReleases = value },
    // Details
        setDefaultNewLabelContracts: (state) => { state.defaultNewLabelContracts = DEFAULT_CONTRACT },
        setLabelContractsUniqueId: (state, uniqueId) => { state.labelContractsUniqueId = uniqueId },
        setLabelContractsDetails: (state, details) => { state.labelContractsDetails = details },
        setLabelContractsLicensorOptions: (state, options) => { state.labelContractsLicensorOptions = options },
        
        // Edit Form FIELDS
        setLabelContractsDetailsAlvId:                      (state, value) => { state.labelContractsDetails.alvId = value },
        setLabelContractsDetailsContractName:               (state, value) => { state.labelContractsDetails.contractName = value },
        setLabelContractsDetailsType:                       (state, value) => { state.labelContractsDetails.contractType = value },
        setLabelContractsDetailsInitialBalance:             (state, value) => { state.labelContractsDetails.initialBalance = value },
        setLabelContractsDetailsInitialBalancePeriod:       (state, value) => { state.labelContractsDetails.initialBalancePeriod = value },
        setLabelContractsDetailsTags:                       (state, value) => { state.labelContractsDetails.tags = value },
        setLabelContractsDetailsContractDate:               (state, value) => { state.labelContractsDetails.contractDate = value },
        setLabelContractsDetailsValidFrom:                  (state, value) => { state.labelContractsDetails.validFrom = value },
        setLabelContractsDetailsValidUntil:                 (state, value) => { state.labelContractsDetails.validUntil = value },
        setLabelContractsDetailsReminderDate:               (state, value) => { state.labelContractsDetails.reminderDate = value },
        setLabelContractsDetailsReserve:                    (state, value) => { state.labelContractsDetails.reserve = value },
        setLabelContractsDetailsResolutionPeriod:           (state, value) => { state.labelContractsDetails.resolutionPeriod = value },
        setLabelContractsDetailsBillingCycle:               (state, value) => { state.labelContractsDetails.billingCycle = value },
        setLabelContractsDetailsConnectedTo:                (state, value) => { state.labelContractsDetails.connectedTo = value },
        setLabelContractsDetailsNotes:                      (state, value) => { state.labelContractsDetails.notes = value },
        setLabelContractsDetailsLicensor:                   (state, value) => { state.labelContractsDetails.licensor = value },

        // period
        setSelectedPeriodNumberLabelContracts: (state, num) => { state.labelContractsDetails.initialBalancePeriod.num = num },
        setSelectedPeriodTimeUnitLabelContracts: (state, period) => { state.labelContractsDetails.initialBalancePeriod.period = period },
        setSelectedPeriodYearLabelContracts: (state, year) => { state.labelContractsDetails.initialBalancePeriod.year = year },
        // SPLITS Panel
        setLabelContractsSplits: (state, splits) => { state.labelContractsSplits = splits },
        setSelectedLabelContractsSplits: (state, splits) => { state.selectedLabelContractsSplits = splits },
        // MEDIA Panel
        setSelectedLabelContractsMediaFiles: (state, mediaFiles) => { state.selectedLabelContractsMediaFiles = mediaFiles },

        // Editing Dialog
        setDefaultLabelContractsSplits: (state) => { state.defaultLabelContractsSplits = DEFAULT_SPLITS },
        setLabelContractsSplitsEditingDialogDetails: (state, details) => { state.labelContractsSplitsEditingDialogDetails = details },
        setLabelContractsSplitsDetailsSalesType: (state, type) => { state.labelContractsSplitsEditingDialogDetails.salesType = type },
        setLabelContractsSplitsDetailsLicense: (state, license) => { state.labelContractsSplitsEditingDialogDetails.license = license },
        setLabelContractsSplitsDetailsSalesUnit: (state, unit) => { state.labelContractsSplitsEditingDialogDetails.salesUnit = unit },
        setLabelContractsSplitsDetailsBase: (state, base) => { state.labelContractsSplitsEditingDialogDetails.base = base },
        setLabelContractsSplitsDetailsShares: (state, share) => { state.labelContractsSplitsEditingDialogDetails.share = share },
        setLabelContractsSplitsDetailsCategory: (state, category) => { state.labelContractsSplitsEditingDialogDetails.category = category },
        // Regions
        setLabelContractsSplitsEditingDialogIncludeOptions: (state, options) => { state.labelContractsSplitsEditingDialogIncludeOptions = options },
        setLabelContractsSplitsEditingDialogExcludeOptions: (state, options) => { state.labelContractsSplitsEditingDialogExcludeOptions = options },
        setLabelContractsSplitsEditingDialogDetailsInclude: (state, include) => { state.labelContractsSplitsEditingDialogDetails.region.include = include },
        setLabelContractsSplitsEditingDialogDetailsExclude: (state, exclude) => { state.labelContractsSplitsEditingDialogDetails.region.exclude = exclude },

        //GROUPED CONTRACTS Panel
        setLabelContractsGroupedContracts: (state, contracts) => { state.labelContractsGroupedContracts = contracts },
        setShowLabelContractsGroupDialog: (state, show) => { state.showLabelContractsGroupDialog = show },
        setLabelContractsGroupDialogName: (state, name) => { state.labelContractsGroupDialogName = name },
        
        // TRACKS/RELEASES Panel
        setLabelContractsTracksReleases: (state, tracks) => { state.labelContractsTracksReleases = tracks },
        setSelectedLabelContractsTracksReleases: (state, selected) => { state.selectedLabelContractsTracksReleases = selected },
        setDefaultLabelContractsTracksReleases: (state) => { state.defaultLabelContractsTracksReleases = DEFAULT_TRACK },
        // Paging
        setLabelContractsTracksReleasesTotalRecords(state, value) { state.labelContractsTracksReleasesTotalRecords = value },
        setLabelContractsTracksReleasesTotalListed(state, value) { state.labelContractsTracksReleasesTotalListed = value },
        setLabelContractsTracksReleasesCurrentPage(state, value) { state.labelContractsTracksReleasesCurrentPage = value },
        setLabelContractsTracksReleasesNumberOfPages(state, value) { state.labelContractsTracksReleasesNumberOfPages = value },
        // Editing Dialog
        setShowLabelContractsTracksReleasesEditingDialog: (state, show) => { state.showLabelContractsTracksReleasesEditingDialog = show },
        // setShowLabelContractsMoveContractsDialog: (state, show) => { state.showLabelContractsMoveContractsDialog = show },
        setLabelContractsTracksReleasesEditingDialogDetails: (state, details) => { state.labelContractsTracksReleasesEditingDialogDetails = details },
        setLabelContractsTracksReleasesDetailsSelectedReleases: (state, releases) => { state.labelContractsTracksReleasesEditingDialogDetails.selectedReleases = releases },
        setLabelContractsTracksReleasesDetailsTrackTitle: (state, title) => { state.labelContractsTracksReleasesEditingDialogDetails.title = title },
        setLabelContractsTracksReleasesDetailsArtist: (state, performer) => { state.labelContractsTracksReleasesEditingDialogDetails.performer = performer },
        setLabelContractsTracksReleasesDetailsIsrc: (state, isrc) => { state.labelContractsTracksReleasesEditingDialogDetails.isrc = isrc },
        // Track Title Autocomplete 
        setLabelContractsTracksReleasesTrackTitleOptions: (state, options) => { state.labelContractsTracksReleasesTrackTitleOptions = options },
        setLabelContractsIsTrackTitelReadOnly: (state, value) => { state.labelContractsIsTrackTitelReadOnly = value },
        // Add Release
        setSelectedReleasesForContract: (state, selected) => { state.selectedReleasesForContract = selected }, 
        setReleasesForContractSearch: (state, search) => { state.releasesForContractSearch = search },
        setTotalReleasesForContractListed: (state, listed) => { state.totalReleasesForContractListed = listed },
        setTotalReleasesForContractRecords: (state, records) => { state.totalReleasesForContractRecords = records },

        setLabelContractsSortingPagingOptions: (state, options) => { state.labelContractsSortingPagingOptions = options },

        // ADVANCE Panel
        setLabelContractsAdvance: (state, advance) => { state.labelContractsAdvance = advance },
        setSelectedLabelContractsAdvance: (state, selected) => { state.selectedLabelContractsAdvance = selected },
        setDefaultLabelContractsAdvance: (state) => { state.defaultLabelContractsAdvance = DEFAULT_ADVANCE },
        setShowLabelContractsAdvanceEditingDialog: (state, show) => { state.showLabelContractsAdvanceEditingDialog = show },
        // Editing
        setLabelContractsAdvanceEditingDialogDetails: (state, details) => { state.labelContractsAdvanceEditingDialogDetails = details },
        setLabelContractsAdvanceDetailsClearanceOfAdvances: (state, text) => { state.labelContractsAdvanceEditingDialogDetails.clearanceOfAdvances = text },
        setLabelContractsAdvanceDetailsCredit: (state, credit) => { state.labelContractsAdvanceEditingDialogDetails.credit = credit },
        setLabelContractsAdvanceDetailsBalance: (state, balance) => { state.labelContractsAdvanceEditingDialogDetails.balance = balance },

        // RESERVES Panel
        setLabelContractsReserves: (state, reserves) => { state.labelContractsReserves = reserves },
        setSelectedLabelContractsReserves: (state, selected) => { state.selectedLabelContractsReserves = selected },
        setDefaultLabelContractsReserves: (state) => { state.defaultLabelContractsReserves = DEFAULT_RESERVES },
        setShowLabelContractsReservesEditingDialog: (state, show) => { state.showLabelContractsReservesEditingDialog = show },
        // Editing
        setLabelContractsReservesEditingDialogDetails: (state, details) => { state.labelContractsReservesEditingDialogDetails = details },
        setLabelContractsReservesDetailsSourceOfReserve: (state, text) => { state.labelContractsReservesEditingDialogDetails.sourceOfReserve = text },
        setLabelContractsReservesDetailsEnteredOn: (state, enteredOn) => { state.labelContractsReservesEditingDialogDetails.enteredOn = enteredOn },
        setLabelContractsReservesDetailsAmount: (state, amount) => { state.labelContractsReservesEditingDialogDetails.amount = amount },
        setLabelContractsReservesDetailsReserve: (state, reserve) => { state.labelContractsReservesEditingDialogDetails.reserve = reserve },
        // Period SetUp AccrualsIn
        setLabelContractsReservesDetailsSetUpAccrualsIn: (state, period) => { state.labelContractsReservesEditingDialogDetails.setUpAccrualsIn = period },
        setSelectedPeriodNumberLabelContractsReservesSetUp: (state, value) => { state.labelContractsReservesEditingDialogDetails.setUpAccrualsIn.num = value },
        setSelectedPeriodTimeUnitLabelContractsReservesSetUp: (state, value) => { state.labelContractsReservesEditingDialogDetails.setUpAccrualsIn.period = value },
        setSelectedPeriodYearLabelContractsReservesSetUp: (state, value) => { state.labelContractsReservesEditingDialogDetails.setUpAccrualsIn.year = value },
        // Period Reverse AccrualsIn
        setLabelContractsReservesDetailsReverseAccrualsIn: (state, period) => { state.labelContractsReservesEditingDialogDetails.reverseAccrualsIn = period },
        setSelectedPeriodNumberLabelContractsReserves: (state, value) => { state.labelContractsReservesEditingDialogDetails.reverseAccrualsIn.num = value },
        setSelectedPeriodTimeUnitLabelContractsReserves: (state, value) => { state.labelContractsReservesEditingDialogDetails.reverseAccrualsIn.period = value },
        setSelectedPeriodYearLabelContractsReserves: (state, value) => { state.labelContractsReservesEditingDialogDetails.reverseAccrualsIn.year = value },

        // COSTS Panel
        setLabelContractsCosts: (state, costs) => { state.labelContractsCosts = costs },
        setSelectedLabelContractsCosts: (state, selected) => { state.selectedLabelContractsCosts = selected },
        setDefaultLabelContractsCosts: (state) => { state.defaultLabelContractsCosts = DEFAULT_COSTS },
        setShowLabelContractsCostsEditingDialog: (state, show) => { state.showLabelContractsCostsEditingDialog = show },
        setLabelContractsCostsAssignToReleaseOptions: (state, options) => { state.labelContractsCostsAssignToReleaseOptions = options },
        // Editing
        setLabelContractsCostsEditingDialogDetails: (state, details) => { state.labelContractsCostsEditingDialogDetails = details },
        setLabelContractsCostsDetailsCostGroup: (state, group) => { state.labelContractsCostsEditingDialogDetails.costGroup = group },
        setLabelContractsCostsDetailsDate: (state, date) => { state.labelContractsCostsEditingDialogDetails.date = date },
        setLabelContractsCostsDetailsPaidOn: (state, date) => { state.labelContractsCostsEditingDialogDetails.paidOn = date },
        setLabelContractsCostsDetailsAmount: (state, amount) => { state.labelContractsCostsEditingDialogDetails.amount = amount },
        setLabelContractsCostsDetailsCountry: (state, country) => { state.labelContractsCostsEditingDialogDetails.country = country },
        setLabelContractsCostsDetailsSplit:                             (state, split) => { state.labelContractsCostsEditingDialogDetails.split = split },
        setLabelContractsCostsDetailsDescription:                       (state, description) => { state.labelContractsCostsEditingDialogDetails.description = description },
        setLabelContractsCostsDetailsDocumentNumber:                    (state, number) => { state.labelContractsCostsEditingDialogDetails.documentNumber = number },
        setLabelContractsCostsDetailsAssignToRelease:                   (state, release) => { state.labelContractsCostsEditingDialogDetails.assignToRelease = release },
        setLabelContractsCostsDetailsRecipient:                         (state, recipient) => { state.labelContractsCostsEditingDialogDetails.recipient = recipient },
        setLabelContractsCostsRecipientOptions:                         (state, options) => { state.labelContractsCostsRecipientOptions = options },
        // AccountingPeriod
        setLabelContractsCostsDetailsAccountingPeriod:                  (state, period) => { state.labelContractsCostsEditingDialogDetails.accountingPeriod = period },
        setSelectedPeriodNumberLabelContractsCostsAccountingPeriod:     (state, value) => { state.labelContractsCostsEditingDialogDetails.accountingPeriod.num = value },
        setSelectedPeriodTimeUnitLabelContractsCostsAccountingPeriod:   (state, value) => { state.labelContractsCostsEditingDialogDetails.accountingPeriod.period = value },
        setSelectedPeriodYearLabelContractsCostsAccountingPeriod:       (state, value) => { state.labelContractsCostsEditingDialogDetails.accountingPeriod.year = value },
        // Paging
        setLabelContractsCostsTotalRecords: (state, total) => { state.labelContractsCostsTotalRecords = total },
        setLabelContractsCostsTotalListed: (state, total) => { state.labelContractsCostsTotalListed = total },
        setLabelContractsCostsCurrentPage: (state, current) => { state.labelContractsCostsCurrentPage = current },
        setLabelContractsCostsNumberOfPages:                            (state, number) => { state.labelContractsCostsNumberOfPages = number },
        // Assign to release
        // setAssignToReleaseOptions: (state, options) => { state.labelContractsDetails.assignToReleaseOptions = options },

        // tracks releases
        setShowTracksReleasesDeleteResultListButton: (state, value) => { state.showTracksReleasesDeleteResultListButton = value },
        setTracksReleasesSearchId: (state, value) => { state.tracksReleasesSearchId = value },
        setLabelContractsTracksReleasesSearch: (state, value) => { state.labelContractsTracksReleasesSearch = value },
        setShowSetTracksReleasesTypeDialog: (state, value) => { state.showSetTracksReleasesTypeDialog = value },
            // MEDIA Panel
        setLabelContractsMedia: (state, media) => { state.labelContractsMedia = media },
        setLabelContractsMediaCheckbox: (state, value) => { state.labelContractsMediaCheckbox = value },
    }

const actions = {
// LIST
    async fetchLabelContracts( { commit, getters }) {  
        commit('setIsLoading', true)
        
        // check for set filters
        let filterObj = {
            'search' :  getters.getLabelContractsSearch,
            'quality': getters.getSelectedLabelContractsQualityFilter,
        }

        // create string of filter params for api call
        let paramsString = this._vm.$alvPlugin.createApiUrlFilterString(filterObj)

        // sorting options
        let options = getters.getLabelContractsServerSideSortingOptions

        // Get list items from db
        let response = await api.getListData2(DIR, getters.getCurrentPage, options.sortBy, options.sortDesc, paramsString)
        // let response = await api.getListData(DIR, getters.getCurrentPage, paramsString)   
        

        if(response === undefined || response.list.length === 0 || response.error === 1) { 
            commit('setNoDataText', 'lang_GENERAL_MESSAGE_NO_RECORDS_FOUND')
            commit('setLabelContracts', [])   
        } else {
            commit('setLabelContracts', response.list)   
        }

        this._vm.$alvPlugin.storePagingInformations(response.filteredRecords, response.currentPage, response.totalRecords)
        commit('setIsLoading', false)
    },

// FETCH REMINDER LIST
async fetchLabelReminders( { commit, getters }) {  
    commit('setIsLoading', true)
    let reminders
    let res = await api.getReminders(DIR, 'reminder')
    if(res === undefined || res.length === 0 || res.error === 1) {
        commit('setNoDataText', 'lang_GENERAL_MESSAGE_NO_RECORDS_FOUND')
        reminders = []
    }else{
        reminders=res.list.map(obj => ({ ...obj, source: 'label' }))
    }
    commit('setLabelReminders', reminders)
    commit('setIsLoading', false)
},


    //MEDIA Panel
    async fetchLabelContractsMedia({ commit, getters }) {
        commit('setIsLoading', true)
        let alvId = getters.getLabelContractsDetailsAlvId
        let mediaFromDB = await api.getListData(DIR + '/' + alvId + '/files' , getters.getCurrentPage)

        if(mediaFromDB === undefined || mediaFromDB === null){
            mediaFromDB = []
        } else if(mediaFromDB.length === 0){
            commit('setNoDataText', 'lang_GENERAL_MESSAGE_NO_RECORDS_FOUND') 
        }else{
            mediaFromDB.forEach((element) => {
                element['isPlaying'] = false
            });
        }
        commit('setLabelContractsMedia', mediaFromDB)
        commit('setIsLoading', false)
    },

    //DELETE MEDIA FILE 

    async deleteSelectedLabelContractsMediaFiles({getters,commit,dispatch}){
        
        let alvId = getters.getLabelContractsDetailsAlvId
        let clickedMediaType = {
            clickedMediaType: getters.getSelectedLabelContractsMediaFiles[0].type,
            mediaFileId: getters.getSelectedLabelContractsMediaFiles[0].id,
        };      

        let response = await api.deleteFile(DIR + "/" + alvId,"?deleteMedia",{"media" : clickedMediaType })
        if(response.error === -1) {
            dispatch("fetchLabelContractsMedia")
            commit('setSnackbar', {
                type: 'success',
                msg: i18n.t('lang_GENERIC_SNACKBAR_DELETE_SUCCESSFUL')
            })
        } else {
            let errorMsg = response.response.errorMsg
            if(errorMsg !== undefined) {
                commit('setSnackbar', {
                    type: 'error',
                    msg: this._vm.$alvPlugin.isLangConst(errorMsg) ? i18n.t(errorMsg) : errorMsg
                })
            }
        }

    },

// DETAILS
    async fetchLabelContractsDetails({ commit, getters, dispatch }, alvId) {
        let values

        if(alvId === 'new') {
            values = JSON.parse(JSON.stringify(getters.getDefaultNewLabelContracts)) 
        }
        else {
            let response = await api.getDetailsById(DIR, alvId) 
            if(response === undefined || response.length === 0 || response.error === 1) {
                values = {}
            } else values = response
        }
        
        if(values.licensor !== null) commit('setLabelContractsLicensorOptions', [values.licensor])
        if(values.initialBalance !== null) values.initialBalance = i18n.n(values.initialBalance, 'number')
        if(values.initialBalancePeriod === null) values.initialBalancePeriod = { "num": null, "period": null, "year": null}
        commit('setLabelContractsDetails', values)
        dispatch('fetchLabelContractsSplits')
        dispatch('fetchLabelContractsGroupedContracts')
        dispatch('fetchLabelContractsAdvance')
        dispatch('fetchLabelContractsReserves')
        if(alvId !== 'new') dispatch('fetchLabelContractsCosts')
        else commit('setLabelContractsCosts', [])
        if(alvId !== 'new') {
            dispatch('fetchLabelContractsTracksReleases');
            dispatch('fetchLabelContractsMedia')

        }
        commit('setIsLoading', false)
    },

    async fetchAutocompleteLabelContractsLicensor({ commit }, input) {
        let response = await api.getAutocompleteSearch('az/persons', input)
        commit('setLabelContractsLicensorOptions', response.list)
    },

// SPLITS Panel
    async fetchLabelContractsSplits({ commit, getters }) {
        let splitsFromDB = await getters.getLabelContractsDetails.splits

        if(splitsFromDB === undefined) return null
        else {
            commit('setLabelContractsSplits', splitsFromDB)
        }
    },
    deleteSelectedLabelContractsSplits({ getters, commit}) {
        let id = getters.getSelectedLabelContractsSplits[0] // only one can be selected
        let index = state.labelContractsSplits.findIndex(split => split.id === id)

        let startSplitsAmount = getters.getLabelContractsSplits.length
        Vue.delete(state.labelContractsSplits, index)
        let newSplitsAmount = getters.getLabelContractsSplits.length
        commit("setSelectedLabelContractsSplits", [])

        if(startSplitsAmount > newSplitsAmount) {
            commit('setSnackbar', { 
                type: 'success', 
                msg: i18n.t('lang_CONTRACTS_PUBLISHING_SNACKBAR_DELETE_SHARES_SUCCESSFUL') + '<br />' + i18n.t('lang_GENERAL_SNACKBAR_TEXT_CLICK_MAIN_SAVE_BUTTON'),
                timeout: -1
            })
        } else {
            commit('setSnackbar', { 
                type: 'error', 
                msg: i18n.t('lang_CONTRACTS_PUBLISHING_SNACKBAR_DELETE_SHARES_NOT_SUCCESSFUL'),
            })
        }

        commit('setSelectedLabelContractsSplits', [])
        if(startSplitsAmount === 0) commit('setNoDataText', 'lang_GENERAL_MESSAGE_NO_RECORDS_FOUND')
    },
    // Editing Splits
    async fetchAutocompleteLabelContractsSplitsEditingDialogInclude({ commit }, input) {
        let items = await api.getRegion(input, i18n.locale)
        commit('setLabelContractsSplitsEditingDialogIncludeOptions', items)
    },
    async fetchAutocompleteLabelContractsSplitsEditingDialogExclude({ commit }, input) {
        let items = await api.getRegion(input, i18n.locale)
        commit('setLabelContractsSplitsEditingDialogExcludeOptions', items)
    },

//GROUPED CONTRACTS PANEL 
    async fetchLabelContractsGroupedContracts({ commit, getters }) {
        let groupedContractsFromDB = await getters.getLabelContractsDetails.groupedContracts

        if(groupedContractsFromDB === undefined) return null
        else {
            commit('setLabelContractsGroupedContracts', groupedContractsFromDB)
        }
    },

// TRACKS/RELEASES Panel 
    // DELETE all tracks releases from Contract
    async deleteAllTracksReleasesFromLabelContract({ getters, commit, dispatch }) {
        commit('setIsLoading', true)
        let contractAlvId = getters.getLabelContractsDetailsAlvId
        let selectedTracksReleases = {}
        let allAlvIds = []

        if(getters.getTotalListed <= 100) {
            getters.getLabelContractsTracksReleases.forEach(lr => {
                allAlvIds.push(lr.alvId)
            })
            selectedTracksReleases = {
                "alvIds" : allAlvIds
            }
        }
        else {
            selectedTracksReleases = {
                "searchId" : getters.getTracksReleasesSearchId
            }
        }
        
        // TODO Veljko check endpoint
        let response = await api.deleteEntries(DIR + '/' + contractAlvId + '?deleteTrack', selectedTracksReleases)
        commit('setIsLoading', false)

        if(response.error === -1) {
            dispatch('saveLabelContractsForm')
            commit('setSnackbar', { 
                type: 'success', 
                msg: i18n.t('lang_GENERIC_SNACKBAR_DELETE_SUCCESSFUL')
            })
        } else {
            commit('setSnackbar', { 
                type: 'error', 
                msg: i18n.t('lang_GENERIC_SNACKBAR_DELETE_NOT_SUCCESSFUL'),
            })
        }

        commit('setTracksReleasesSearchId', null)
    },
    async fetchDialogCsvLink({ commit, getters }) {
        commit('setIsLoading', true)
        let contractAlvId = getters.getLabelContractsDetailsAlvId
        let response = await api.getDetailsById(DIR, contractAlvId, '/listTracksReleases')
        commit('setDialogSvgLink', response.path)
        commit('setIsLoading', false)
    },
    async setAllTracksReleases({ commit, getters }) {
        commit('setIsLoading', true)
        let alvId = getters.getLabelContractsDetailsAlvId
        await api.triggerAction(DIR + '/' + alvId, {}, { action: 'connectAllTracksWithReleases' })
        commit('setIsLoading', false)
    },
    async fetchLabelContractsTracksReleases({ commit, getters }) {
        commit('setIsLoading', true)
        // TODO Veljko check getter searchInput
        var searchInput = getters.getLabelContractsTracksReleasesSearch
        // check for set filters
        let filterObj = {
            'search' :  getters.getLabelContractsTracksReleasesSearch,
        }

        // create string of filter params for api call
        let paramsString = this._vm.$alvPlugin.createApiUrlFilterString(filterObj)
        let options = getters.getLabelContractsSortingPagingOptions
        let contractAlvId = getters.getLabelContractsDetailsAlvId

        let response = await api.getListData2(DIR + '/' + contractAlvId + '/tracks', getters.getLabelContractsTracksReleasesCurrentPage, options.sortBy, options.sortDesc, paramsString)
        // let response = await api.getListData(DIR + '/' + contractAlvId + '/tracks')

        if(response === undefined || response.list.length === 0 || response.error === 1) { 
            commit('setNoDataText', 'lang_GENERAL_MESSAGE_NO_RECORDS_FOUND')
            commit('setLabelContractsTracksReleases', [])   
        } else {
            if(searchInput !== null && searchInput !== '' && response.list.length !== 0) {
                commit('setShowTracksReleasesDeleteResultListButton', true)
                commit('setTracksReleasesSearchId', response.searchId)
            } else {
                commit('setShowTracksReleasesDeleteResultListButton', false)
                commit('setTracksReleasesSearchId', null)
            }
            commit('setLabelContractsTracksReleases', response.list)   
        }
        commit('setLabelContractsTracksReleasesTotalListed', response.filteredRecords)
        commit('setLabelContractsTracksReleasesTotalRecords', response.totalRecords)
        commit('setLabelContractsTracksReleasesCurrentPage', response.currentPage)
        commit('setLabelContractsTracksReleasesNumberOfPages', response.numberOfPages)
        
        // Removed this because it commits to main 'setTotalRecords', which will cause dissapearing of data from BaseDataTableList in list page
        // this._vm.$alvPlugin.storePagingInformations(response.filteredRecords, response.currentPage, response.totalRecords, response.numberOfPages)
        
        commit('setIsLoading', false)
    },
    // AUTOCOMPLETE Tracks
    async fetchAutocompleteLabelContractsTracksReleasesTrackTitle({ commit }, input) {
        let response = await api.getAutocompleteSearch('label/tracks', input)
        commit('setLabelContractsTracksReleasesTrackTitleOptions', response.list)
    },
    // SEARCH + ADD releases
    async searchReleasesForContract({ getters }) {
        // let params = "search=" + getters.getReleasesForContractSearch + '&labelContractId=' +  getters.getLabelContractsDetailsAlvId
        let params = "search=" + getters.getReleasesForContractSearch
        let response = await api.getFilteredResults("label/releases", params)
        return response.list
    },
    async addReleasesToContract({ getters, dispatch, commit }) {
        let contractAlvId = getters.getLabelContractsDetailsAlvId
        let selectedReleases = getters.getSelectedReleasesForContract
        let context = "addReleases"
        
        let metaData = {
            "alvIds": selectedReleases
        }
        let response = await api.addMultipleRowsToDataTable(DIR + '/' + contractAlvId, metaData, context) 
        
        if(response.error === -1) {
            commit('setSnackbar', { 
                type: 'success', 
                msg: i18n.t('lang_GENERIC_SNACKBAR_ADDING_WAS_SUCCESSFUL'),
            })
            dispatch('fetchLabelContractsTracksReleases')
        } else {
            commit('setSnackbar', { 
                type: 'error', 
                msg: i18n.t('lang_GENERIC_SNACKBAR_ADDING_WAS_NOT_SUCCESSFUL'),
            })
        }
    },
    async addTrackToLabelContract({ getters, commit, dispatch }) {
        let contractAlvId = getters.getLabelContractsDetailsAlvId
        let addTrackDialogDetails = getters.getLabelContractsTracksReleasesEditingDialogDetails

        let response = await api.addRowToDataTable(DIR + '/' + contractAlvId, addTrackDialogDetails, "addTrack")

        if(response.error === -1) {
            commit('setSnackbar', { 
                type: 'success', 
                msg: i18n.t('lang_GENERIC_SNACKBAR_ADDING_WAS_SUCCESSFUL'),
            })
            dispatch('fetchLabelContractsTracksReleases')
        } else {
            commit('setSnackbar', { 
                type: 'error', 
                msg: i18n.t('lang_GENERIC_SNACKBAR_ADDING_WAS_NOT_SUCCESSFUL'),
            })
        }
    },
    // DELETE
    async deleteSelectedLabelContractsTracksReleases({ getters, commit, dispatch }) {
        let contractAlvId = getters.getLabelContractsDetailsAlvId
        let selectedTrackAlvId = getters.getSelectedLabelContractsTracksReleases // only one id is passed
        
        let response = await api.deleteEntries(DIR + '/' + contractAlvId + '?deleteTrack', [selectedTrackAlvId])

        if(response.error === -1) {
            dispatch('fetchLabelContractsTracksReleases')
            commit('setSnackbar', { 
                type: 'success', 
                msg: i18n.t('lang_LABEL_RELEASES_SNACKBAR_DELETE_TRACK_SUCCESSFUL')
            })
        } else {
            commit('setSnackbar', { 
                type: 'error', 
                msg: i18n.t('lang_LABEL_RELEASES_SNACKBAR_DELETE_TRACK_NOT_SUCCESSFUL'),
            })
        }

        commit('setSelectedLabelContractsTracksReleases', [])
    },

    // ADVANCE PANEL
    async fetchLabelContractsAdvance({ getters, commit, dispatch }) {
        let advance = getters.getLabelContractsDetails.advance
        commit('setIsLoading', false)

        if(advance === undefined) {
            commit('setNoDataText', 'lang_GENERAL_MESSAGE_NO_RECORDS_FOUND')
            advance = []
        }
        
        commit('setLabelContractsAdvance', advance)
        dispatch('calculateLabelContractsAdvanceBalance')
    },
    // DELETE Advance
    async deleteSelectedLabelContractsAdvance({ getters, commit, dispatch}) {
        let selectedAdvance = getters.getSelectedLabelContractsAdvance
        let advance = getters.getLabelContractsAdvance
        let index = advance.findIndex(text => text.id === selectedAdvance.id)

        // delete selected advance
        let startAmount = advance.length
        Vue.delete(advance, index)
        let newAmount = advance.length

        // calculate the new balances
        await dispatch("calculateLabelContractsAdvanceBalance")
        let newAdvance = getters.getLabelContractsAdvance

        // if the user deleted the last row in advance and the length is 0 it was successfull.       
        if(newAdvance.length === 0) {
            commit('setSnackbar', { 
                type: 'success', 
                msg: i18n.t('lang_GENERIC_SNACKBAR_DELETE_SUCCESSFUL') + '<br />' + i18n.t('lang_GENERAL_SNACKBAR_TEXT_CLICK_MAIN_SAVE_BUTTON'),
            })
            commit('setSelectedLabelContractsAdvance', [])
            if(newAmount === 0) commit('setNoDataText', 'lang_GENERAL_MESSAGE_NO_RECORDS_FOUND')
        } 
        // if it was not the last one we have to check if the entry can be deleted, 
        // for that the new balance is not allowed to be bigger than 0.
        else {
            // if deleting the entry leads to balance over 0, we have to warn the user, 
            // that this can not happen and put the deleted item back in the list!
            if(newAdvance[0].balance > 0) {
                commit('setSnackbar', { 
                    type: 'error', 
                    msg: i18n.t("lang_CONTRACTS_LABEL_ADVANCE_PANEL_SNACKBAR_BALANCE_TOO_HIGH"), 
                })
                advance.splice(index, 0, selectedAdvance)
                commit('setLabelContractsAdvance', advance)
            } else {
                // to make sure the selected entry was really deleted we check if the new amount is less than before,
                // and show a snackbar to the user
                if(startAmount > newAmount) {
                    commit('setSnackbar', { 
                        type: 'success', 
                        msg: i18n.t('lang_GENERIC_SNACKBAR_DELETE_SUCCESSFUL') + '<br />' + i18n.t('lang_GENERAL_SNACKBAR_TEXT_CLICK_MAIN_SAVE_BUTTON'),
                    })
                } else {
                    commit('setSnackbar', { 
                        type: 'error', 
                        msg: i18n.t('lang_GENERIC_SNACKBAR_DELETE_NOT_SUCCESSFUL'), 
                    })
                }
            }

            commit('setSelectedLabelContractsAdvance', [])
            if(newAmount === 0) commit('setNoDataText', 'lang_GENERAL_MESSAGE_NO_RECORDS_FOUND')
        }
    },
    // CALCULATE Balance
    async calculateLabelContractsAdvanceBalance({ getters, commit }) {
        let advance = JSON.parse(JSON.stringify(getters.getLabelContractsAdvance))
        advance.reverse()
        advance.reduce(function(prevValue, item){
            item.balance = prevValue + item.credit
            return item.balance
        }, 0)
        advance.reverse()
        commit('setLabelContractsAdvance', advance)
    },

    // RESERVES Panel
    async fetchLabelContractsReserves({ getters, commit }) {
        let reserves = getters.getLabelContractsDetails.reserves
        commit('setIsLoading', false)

        if(reserves === undefined) {
            commit('setNoDataText', 'lang_GENERAL_MESSAGE_NO_RECORDS_FOUND')
            reserves = []
        }

        commit('setLabelContractsReserves', reserves)
    },
    // DELETE Reserves
    async deleteSelectedLabelContractsReserves({ getters, commit }) {
        let selectedReserves = getters.getSelectedLabelContractsReserves
        let index = getters.getLabelContractsReserves.findIndex(text => text.id === selectedReserves.id)

        let startAmount = getters.getLabelContractsReserves.length
        Vue.delete(getters.getLabelContractsReserves, index)
        let newAmount = getters.getLabelContractsReserves.length

        if(startAmount > newAmount) {
            commit('setSnackbar', { 
                type: 'success', 
                msg: i18n.t('lang_GENERIC_SNACKBAR_DELETE_SUCCESSFUL') + '<br />' + i18n.t('lang_GENERAL_SNACKBAR_TEXT_CLICK_MAIN_SAVE_BUTTON'),
            })
        } else {
            commit('setSnackbar', { 
                type: 'error', 
                msg: i18n.t('lang_GENERIC_SNACKBAR_DELETE_NOT_SUCCESSFUL'), 
            })
        }

        commit('setSelectedLabelContractsReserves', [])
        if(newAmount === 0) commit('setNoDataText', 'lang_GENERAL_MESSAGE_NO_RECORDS_FOUND')
    },

    // COSTS Panel
    async fetchLabelContractsCosts({ getters, commit }) {
        commit('setIsLoading', true)
        let contractAlvId = getters.getLabelContractsDetailsAlvId
        let response = await api.getListData(DIR + '/' + contractAlvId + '/costs', getters.getLabelContractsCostsCurrentPage)

        if(response === undefined || response.list.length === 0 || response.error === 1) { 
            commit('setNoDataText', 'lang_GENERAL_MESSAGE_NO_RECORDS_FOUND')
            commit('setLabelContractsCosts', [])   
        } else {
            commit('setLabelContractsCosts', response.list)
            // Pageing
            commit('setLabelContractsCostsTotalRecords', response.totalRecords)
            commit('setLabelContractsCostsTotalListed', response.filteredRecords)
            commit('setLabelContractsCostsCurrentPage', response.currentPage)
            commit('setLabelContractsCostsNumberOfPages', response.numberOfPages)
        }       
        // this._vm.$alvPlugin.storePagingInformations(
        //     response.filteredRecords, 
        //     response.currentPage, 
        //     response.totalRecords, 
        //     response.numberOfPages
        // )
        commit('setIsLoading', false)
    },
    // DELETE costs
    async deleteSelectedLabelContractsCosts({ getters, commit, dispatch}) {
        let contractAlvId = getters.getLabelContractsDetailsAlvId
        let selectedCosts = getters.getSelectedLabelContractsCosts

        let reponse = await api.deleteEntries(DIR + '/' + contractAlvId + '?deleteCost', [selectedCosts.alvId])

        if(reponse.error === -1) {
            dispatch('fetchLabelContractsCosts')
            commit('setSnackbar', { 
                type: 'success', 
                msg: i18n.t('lang_GENERIC_SNACKBAR_DELETE_SUCCESSFUL'),
            })
        } else {
            commit('setSnackbar', { 
                type: 'error', 
                msg: i18n.t('lang_GENERIC_SNACKBAR_DELETE_NOT_SUCCESSFUL'), 
            })
        }
        
        commit('setSelectedLabelContractsCosts', [])
    },
    // FETCH Recipient for costs
    async fetchAutocompleteLabelContractsCostsRecipient({ commit }, input) {
        let response = await api.getAutocompleteSearch('az/persons', input)
        commit('setLabelContractsCostsRecipientOptions', response.list)
    },

    // FETCH VÖ to assign to costs
    //Was required for Autocomplete Dropdown which is not there anymore 
    async fetchAutocompleteLabelContractsCostsAssignToRelease({ commit, getters }, input) {
        let response = await api.getAutocompleteSearch('label/releases', input)
        commit('setLabelContractsCostsAssignToReleaseOptions', response.list)
    },
    async fetchAssignToReleaseDropdown({ commit, getters }) {
        let alvId = getters.getLabelContractsDetailsAlvId

        let assignToReleaseDropdown = await api.getSpecificDropdownValues(DIR, alvId, 'releases')
        assignToReleaseDropdown.forEach(release => {
            release['text'] = release.title + ' (' + this._vm.$alvPlugin.getProductItemIdLabelReleases(release) + ')'
        });
        commit('setLabelContractsCostsAssignToReleaseOptions', assignToReleaseDropdown)
    },

    // ADD/EDIT costs
    async addLabelContractsCosts({ getters, commit, dispatch }) {
        let contractAlvId = getters.getLabelContractsDetailsAlvId
        let costsDetails = getters.getLabelContractsCostsEditingDialogDetails

        let response = await api.addRowToDataTable(DIR + '/' + contractAlvId, costsDetails, "addCosts")

        if(response.error === -1) {
            commit('setSnackbar', { 
                type: 'success', 
                msg: i18n.t('lang_GENERIC_SNACKBAR_ADDING_WAS_SUCCESSFUL'),
            })
        } else {
            commit('setSnackbar', { 
                type: 'error', 
                msg: i18n.t('lang_GENERIC_SNACKBAR_ADDING_WAS_NOT_SUCCESSFUL'),
            })
        }

        dispatch('fetchLabelContractsCosts')
    },

    // SAVE
    async saveLabelContractsForm({ getters, commit, dispatch }) {
        let alvId = getters.getLabelContractsDetailsAlvId
        getters.getLabelContractsDetails.advance = getters.getLabelContractsAdvance
        getters.getLabelContractsDetails.reserves = getters.getLabelContractsReserves
        getters.getLabelContractsDetails.costs = getters.getLabelContractsCosts
        let metaData = _.cloneDeep(getters.getLabelContractsDetails)
        let isNew = router.currentRoute.params.alvId == "new"
        if(metaData.initialBalance === '') metaData.initialBalance = null
        metaData.initialBalance = this._vm.$alvPlugin.normalizeDecimalFormat(metaData.initialBalance)

        let response = await api.saveEditForm(DIR, alvId, metaData, isNew)

        if(response === undefined || response.length === 0 || response.error === 1) { 
            response = []
            commit('setSnackbar', { 
                type: 'error', 
                msg: i18n.t('lang_GENERAL_CAPTION_ERROR'),
            })
        } else {
            commit('setSnackbar', { 
                type: 'success', 
                msg: i18n.t('lang_CONTRACTS_LABEL_SNACKBAR_CONTRACT_SAVED')
            })
            
            // redirect for url now with ALVID
            if(isNew) {
                router.push( { name: 'LabelContractsEdit', params: { alvId:  response.response.alvId } })
            }

            // refresh data
            await dispatch('fetchLabelContractsDetails',  response.response.alvId)
        }
    },

// ACTIONS Switch
    async doLabelContractsAction({ commit, dispatch, getters }) {
        let selectedContracts = getters.getSelectedLabelContracts
               
        if(selectedContracts.length > 0) {
            switch (getters.getSelectedLabelContractsAction) {
                case 'delete':
                    commit('setShowDeletionDialog', true)
                break
                case 'replaceTags':
                    commit('setShowManageTagsDialog', true)
                break
                case 'copyWithTracks': case 'copyWithoutTracks':
                    if(selectedContracts.length === 1) {
                        dispatch('copyLabelContract')
                    } else {
                        commit('setSelectionRequiredText', 'lang_GENERAL_SELECTION_REQUIRED_DIALOG_TEXT_ONLY_ONE') 
                        commit('setShowSelectionRequiredDialog', true)
                    }
                break
                case 'move':
                    commit('setShowMoveContractsDialog',true)
                break
            }
        } else {
            commit('setSelectionRequiredText', 'lang_GENERAL_SELECTION_REQUIRED_DIALOG_TEXT_AT_LEAST_ONE') 
            commit('setShowSelectionRequiredDialog', true)
        }

        if(getters.getSelectedLabelContractsAction === 'export'){
            commit('setSelectionRequiredText', '') 
            commit('setShowSelectionRequiredDialog', false)
            if(selectedContracts.length === 0){
                //Export All
                let r = await dispatch('runConfirmationDialog')
                if(r){
                    commit('setContractsLabelExportAll', true)
                    commit('setShowContractsLabelExportDialog',true)
                }
            }else{
                commit('setContractsLabelExportAll', false)
                commit('setShowContractsLabelExportDialog', true)
            }
            
        } 
        if(getters.getSelectedLabelContractsAction === 'groupContracts'){
            if(selectedContracts.length < 2){
                commit('setSelectionRequiredText', 'lang_GENERAL_SELECTION_REQUIRED_DIALOG_TEXT_MORE_THAN_ONE') 
                commit('setShowSelectionRequiredDialog', true)
            }else{
                commit('setLabelContractsGroupDialogName', '')
                dispatch('fetchExistingLabelGroupName')
                commit('setShowLabelContractsGroupDialog', true)
            }
        }else if(getters.getSelectedLabelContractsAction === 'ungroupContracts'){
            if(selectedContracts.length === 0){
                commit('setSelectionRequiredText', 'lang_GENERAL_SELECTION_REQUIRED_DIALOG_TEXT_AT_LEAST_ONE') 
                commit('setShowSelectionRequiredDialog', true)
            }else{
                dispatch('ungroupLabelContracts')
            }
        }
    },
    // Action: DELETE
    async deleteSelectedLabelContracts({ getters, commit, dispatch  }) {
        const response = await api.deleteEntries(DIR, getters.getSelectedLabelContracts)
        if(response.error === -1) {
            for(let i = 0; i < getters.getSelectedLabelContracts.length; i++) {
                let index = getters.getLabelContracts.findIndex(contract => contract.alvId == getters.getSelectedLabelContracts[i])
                Vue.delete(getters.getLabelContracts, index)
            }
        }

        commit('setSnackbar', {
            type: 'success',
            msg: i18n.t('lang_GENERIC_SNACKBAR_ENTRY_DELETED')
        })
        
        commit('setSelectedLabelContracts', [])
        commit('setSelectedLabelContractsAction', [])
        dispatch('fetchLabelContracts')
    },

    // Action: MOVE
    async moveSelectedLabelContracts({ getters, commit, dispatch  }) {

        let metaData = { "alvIds" : getters.getSelectedLabelContracts,
                         "company" : getters.getLabelContractsDetailsSelectedCompany }
        let queryParams = { "action": 'move'}
        const response = await api.triggerAction(DIR,metaData,queryParams)


        if(response.error === -1) {
            commit('setSnackbar', {
                type: 'success',
                msg: i18n.t('lang_GENERIC_SNACKBAR_ENTRY_MOVED')
            })
        }
        
        commit('setSelectedLabelContracts', [])
        commit("setIsAllSelectedLabelContracts",false)
        commit('setSelectedLabelContractsAction', [])
        dispatch('fetchLabelContracts')
    },

    // Action: COPY
    async copyLabelContract({ getters, commit, dispatch }) {
        let selectedActionValue = getters.getSelectedLabelContractsAction
        let queryParams = { "action": selectedActionValue }
        let metaData = { "alvIds" : getters.getSelectedLabelContracts }

        let response = await api.triggerAction(DIR, metaData, queryParams)

        if(response.error === -1) {
            commit('setSnackbar', {
                type: 'success',
                msg: i18n.t('lang_GENERAL_SNACKBAR_COPY_SUCCESSFULL')
            })
            dispatch('fetchLabelContracts')
        } else {
            let errorMsg = response.response.errorMsg
            if(errorMsg !== undefined) {
                commit('setSnackbar', {
                    type: 'error',
                    msg: this._vm.$alvPlugin.isLangConst(errorMsg) ? i18n.t(errorMsg) : errorMsg
                })
            }
        }
    },

    async fetchExistingLabelGroupName({ getters, commit }) {
        let selected = getters.getSelectedLabelContracts
        if(selected.length > 0) {
            let response = await api.getDetailsById(DIR, selected[0])
            if(response && response.groupedContracts && response.groupName) {
                commit('setLabelContractsGroupDialogName', response.groupName)
            }
        }
    },

    async groupLabelContracts({ getters, commit, dispatch }){

        let selected = getters.getSelectedLabelContracts

        let queryParams = { "action": "groupContracts" }
        let metaData = { "alvIds" : selected, "groupName": getters.getLabelContractsGroupDialogName }

        let response = await api.triggerAction(DIR, metaData, queryParams)

        if(response.error === -1) {
            commit('setSnackbar', {
                type: 'success',
                msg: i18n.t('lang_CONTRACTS_PUBLISHING_SNACKBAR_CONTRACT_SAVED')
            })
            dispatch('fetchLabelContracts')
        } else {
            let errorMsg = response.response.errorMsg
            if(errorMsg !== undefined) {
                commit('setSnackbar', {
                    type: 'error',
                    msg: this._vm.$alvPlugin.isLangConst(errorMsg) ? i18n.t(errorMsg) : errorMsg
                })
            }
        }
    },
    async ungroupLabelContracts({ getters, commit, dispatch }){

        let selected = getters.getSelectedLabelContracts

        let queryParams = { "action": "ungroupContracts" }
        let metaData = { "alvIds" : selected }

        let response = await api.triggerAction(DIR, metaData, queryParams)

        if(response.error === -1) {
            commit('setSnackbar', {
                type: 'success',
                msg: i18n.t('lang_CONTRACTS_PUBLISHING_SNACKBAR_CONTRACT_SAVED')
            })
            dispatch('fetchLabelContracts')
        } else {
            let errorMsg = response.response.errorMsg
            if(errorMsg !== undefined) {
                commit('setSnackbar', {
                    type: 'error',
                    msg: this._vm.$alvPlugin.isLangConst(errorMsg) ? i18n.t(errorMsg) : errorMsg
                })
            }
        }
    },
    // ACTION Export (type - mappings)
    async exportContractsLabelMapping({ commit, getters }) {
        commit('setIsLoading', true)
        let queryParams = {
          action: "export",
          type: "mappings",
          mappingId: getters.getContractsLabelExportDetailsMappingId,
        };
        // Support both select contract by checkbox and whole search result
        let metaData = { 
            alvIds: getters.getSelectedLabelContracts, 
            exportAll: getters.getContractsLabelExportAll ? 1 : 0,
            includeTracksReleases: getters.getContractsLabelExportTracksReleasesCheckbox ? 'yes' : 'no' 
        };
    
        let response =  await api.triggerAction(DIR, metaData, queryParams);

        if (response.error === -1) {
          if (response.response.path !== null) {
            api.getFileFromALV(response.response.path);
            commit("setSnackbar", {
              type: "success",
              msg: i18n.t("lang_GENERAL_SNACKBAR_DOWNLOAD_SUCCESSFULL"),
            });
          }
        } else {
          let errorMsg = response.response.errorMsg;
          if (errorMsg !== undefined) {
            commit("setSnackbar", {
              type: "error",
              msg: this._vm.$alvPlugin.isLangConst(errorMsg)
                ? i18n.t(errorMsg)
                : errorMsg,
            });
          }
        }

        commit("setIsLoading", false);
    }
    
}

export default {
    state, getters, actions, mutations
}